import styled from 'styled-components';

import { BorderRadius } from '@r1-frontend/ui-react/tokens/borderRadius';

export const Wrapper = styled.div`
  display: block;
  width: 100%;
  
  & > div {
    border-radius: ${BorderRadius.OuterBlockRadius};
  }
`;
